export default __webpack_public_path__ + "static/media/alert.d2d328c7.gif";